import {
  apiRequest,
  RiwayatNikahUpdate,
  RiwayatNikahDetail,
  masterRegion,
  masterGajiwebSatker,
  CoupleList,
} from "../../../../../services/adapters/kepegawaian/riwayatnikahService";

class UpdateRepository {
  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      RiwayatNikahDetail,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      RiwayatNikahUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchCouple = async (query) => {
    return await apiRequest(
      "get",
      CoupleList,
      {
        params: query,
      },
      true
    );
  };

  fetchSatkerGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebSatker,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
